import React from 'react';
import { ServicePackageCard } from '../../shared';

const ServicesTab = ({ service }) => {
  return (
    <div>
      <h3 className="text-lg sm:text-xl font-light text-black mb-6">Service Packages</h3>
      <div className="space-y-4">
        {service?.vendor_service_packages?.length > 0 ? (
          service.vendor_service_packages.map((pkg) => (
            <ServicePackageCard key={pkg.id} package={pkg} />
          ))
        ) : (
          <div className="text-center py-8">
            <p className="text-gray-600 font-light">No service packages available for this service.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServicesTab;

